import React from "react";
import { makeStyles } from "@mui/styles";

import { Link } from "react-router-dom";

import { Grid } from "@mui/material";

import CodeCard from "../../../components/shared/CodeCard.js";

const useStyles = makeStyles({
  firstHeader: {
    marginTop: "10px",
  },
});

function Overview() {
  const classes = useStyles();

  return (
    <Grid container spacing={0}>
      <Grid item md={8}>
        <h2 className={classes.firstHeader}>Overview</h2>
        <h3>Access</h3>
        <p>
          To access the v2 API, you must obtain an access token by following the
          steps outlined in the{" "}
          <Link to="/apidoc/authentication">Authentication</Link> section.
        </p>
        <p>
          Once you have this access token, make all your API calls with this
          token in the header of the request. The header should have the format
          of:
        </p>
        <CodeCard>
          Authorization: Bearer &#123;access_token&#125;
          <br />
          Host: api.sosinventory.com
        </CodeCard>
        <p>For example:</p>
        <CodeCard>
          Authorization: Bearer JdqRERTTeJ86Ci
          <br />
          Host: api.sosinventory.com
        </CodeCard>
        <h3>Usage</h3>
        <p>All calls to the v2 API follow the URL pattern below:</p>
        <CodeCard>
          https://api.sosinventory.com/api/v2/&#123;endpoint&#125;
        </CodeCard>
        <h3>Throttling</h3>
        <p>
          To ensure responsiveness for all SOS Inventory customers, you must not
          issue API requests more frequently than every 500ms. More frequent
          requests will not be executed. They will return a 200 status code with
          the message, “Throttle limit exceeded.”
        </p>
      </Grid>
    </Grid>
  );
}

export default Overview;
